import React from 'react';
import classNameBind from 'classnames/bind';
import Icon from '../Icon';
import StyledContainer from '../StyledContainer';
import styles from './Carousel.module.css';

const bindClasses = classNameBind.bind(styles);

class Carousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSlide: props.startFromIndex,
    };

    this.queueNextSlide();
  }

  componentDidUpdate(prevProps, prevState) {
    const { currentSlide } = this.state;

    if (prevState.currentSlide !== currentSlide) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.queueNextSlide();
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  queueNextSlide = () => {
    const { slidesInterval } = this.props;
    const { currentSlide } = this.state;

    if (!slidesInterval) return;

    this.timeout = setTimeout(() => { this.setState({ currentSlide: this.makeItSpin(currentSlide + 1) }); }, slidesInterval * 1000);
  }

  makeItSpin = (number) => {
    const { slides } = this.props;

    if (number < 0) return slides.length - 1;
    if (number >= slides.length) return 0;

    return number;
  };

  render() {
    const { slides, dataId, withBackground } = this.props;
    const { currentSlide } = this.state;

    const arrow = isLeft => (
      <div
        onClick={() => this.setState({ currentSlide: this.makeItSpin(currentSlide + (isLeft ? -1 : 1)) })}
        role="button"
        tabIndex={-1}
        className={bindClasses('arrow', isLeft ? 'left' : 'right')}
      >
        <Icon name={`arrow-${isLeft ? 'left' : 'right'}`} />
      </div>
    );

    return (
      <StyledContainer backgroundImage={withBackground ? 'image1' : 'none'} dataId={dataId}>
        <div className={bindClasses('wrapper')}>
          {slides.map((el, index) => (
            <div className={bindClasses('slide', { hidden: index !== currentSlide })} key={index}>
              {el}
            </div>
          ))}
          {arrow(true)}
          {arrow()}
        </div>
      </StyledContainer>
    );
  }
}

Carousel.defaultProps = {
  slides: [],
  startFromIndex: 0,
  dataId: 'Carousel',
  slidesInterval: 0,
  withBackground: false,
};

export default Carousel;
